import axios from "axios";

type GetProtocolNumberResponse = {
    data?: [];
    error?: string;
} | null;

    export const getProtocolNumber = async (): Promise<GetProtocolNumberResponse> => {
        const apiUrl = `${process.env.REACT_APP_PROXY_URL}/v1/getStudyNumber`;
        try {
            const response = await axios.post(
                apiUrl, null, {
                    headers: {
                        Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
                        "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY
                    }
                }
            );
             return response;
        } catch (err) {
            if (axios.isAxiosError(err) && err?.response) {
                return { error: err?.response?.data?.message || "An error occurred" };
            }
                return { error: "An unexpected error occurred" };
        }
    };
